!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.pa = t());
}(this, function () {
  "use strict";

  return [{
    locale: "pa",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      return t ? "other" : 0 == e || 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "ਸਾਲ",
        relative: {
          0: "ਇਹ ਸਾਲ",
          1: "ਅਗਲਾ ਸਾਲ",
          "-1": "ਪਿਛਲਾ ਸਾਲ"
        },
        relativeTime: {
          future: {
            one: "{0} ਸਾਲ ਵਿੱਚ",
            other: "{0} ਸਾਲਾਂ ਵਿੱਚ"
          },
          past: {
            one: "{0} ਸਾਲ ਪਹਿਲਾਂ",
            other: "{0} ਸਾਲ ਪਹਿਲਾਂ"
          }
        }
      },
      "year-short": {
        displayName: "ਸਾਲ",
        relative: {
          0: "ਇਹ ਸਾਲ",
          1: "ਅਗਲਾ ਸਾਲ",
          "-1": "ਪਿਛਲਾ ਸਾਲ"
        },
        relativeTime: {
          future: {
            one: "{0} ਸਾਲ ਵਿੱਚ",
            other: "{0} ਸਾਲਾਂ ਵਿੱਚ"
          },
          past: {
            one: "{0} ਸਾਲ ਪਹਿਲਾਂ",
            other: "{0} ਸਾਲ ਪਹਿਲਾਂ"
          }
        }
      },
      month: {
        displayName: "ਮਹੀਨਾ",
        relative: {
          0: "ਇਹ ਮਹੀਨਾ",
          1: "ਅਗਲਾ ਮਹੀਨਾ",
          "-1": "ਪਿਛਲਾ ਮਹੀਨਾ"
        },
        relativeTime: {
          future: {
            one: "{0} ਮਹੀਨੇ ਵਿੱਚ",
            other: "{0} ਮਹੀਨਿਆਂ ਵਿੱਚ"
          },
          past: {
            one: "{0} ਮਹੀਨਾ ਪਹਿਲਾਂ",
            other: "{0} ਮਹੀਨੇ ਪਹਿਲਾਂ"
          }
        }
      },
      "month-short": {
        displayName: "ਮਹੀਨਾ",
        relative: {
          0: "ਇਹ ਮਹੀਨਾ",
          1: "ਅਗਲਾ ਮਹੀਨਾ",
          "-1": "ਪਿਛਲਾ ਮਹੀਨਾ"
        },
        relativeTime: {
          future: {
            one: "{0} ਮਹੀਨੇ ਵਿੱਚ",
            other: "{0} ਮਹੀਨਿਆਂ ਵਿੱਚ"
          },
          past: {
            one: "{0} ਮਹੀਨਾ ਪਹਿਲਾਂ",
            other: "{0} ਮਹੀਨੇ ਪਹਿਲਾਂ"
          }
        }
      },
      day: {
        displayName: "ਦਿਨ",
        relative: {
          0: "ਅੱਜ",
          1: "ਭਲਕੇ",
          "-1": "ਬੀਤਿਆ ਕੱਲ੍ਹ"
        },
        relativeTime: {
          future: {
            one: "{0} ਦਿਨ ਵਿੱਚ",
            other: "{0} ਦਿਨਾਂ ਵਿੱਚ"
          },
          past: {
            one: "{0} ਦਿਨ ਪਹਿਲਾਂ",
            other: "{0} ਦਿਨ ਪਹਿਲਾਂ"
          }
        }
      },
      "day-short": {
        displayName: "ਦਿਨ",
        relative: {
          0: "ਅੱਜ",
          1: "ਭਲਕੇ",
          "-1": "ਬੀਤਿਆ ਕੱਲ੍ਹ"
        },
        relativeTime: {
          future: {
            one: "{0} ਦਿਨ ਵਿੱਚ",
            other: "{0} ਦਿਨਾਂ ਵਿੱਚ"
          },
          past: {
            one: "{0} ਦਿਨ ਪਹਿਲਾਂ",
            other: "{0} ਦਿਨ ਪਹਿਲਾਂ"
          }
        }
      },
      hour: {
        displayName: "ਘੰਟਾ",
        relative: {
          0: "ਇਸ ਘੰਟੇ"
        },
        relativeTime: {
          future: {
            one: "{0} ਘੰਟੇ ਵਿੱਚ",
            other: "{0} ਘੰਟਿਆਂ ਵਿੱਚ"
          },
          past: {
            one: "{0} ਘੰਟਾ ਪਹਿਲਾਂ",
            other: "{0} ਘੰਟੇ ਪਹਿਲਾਂ"
          }
        }
      },
      "hour-short": {
        displayName: "ਘੰਟਾ",
        relative: {
          0: "ਇਸ ਘੰਟੇ"
        },
        relativeTime: {
          future: {
            one: "{0} ਘੰਟੇ ਵਿੱਚ",
            other: "{0} ਘੰਟਿਆਂ ਵਿੱਚ"
          },
          past: {
            one: "{0} ਘੰਟਾ ਪਹਿਲਾਂ",
            other: "{0} ਘੰਟੇ ਪਹਿਲਾਂ"
          }
        }
      },
      minute: {
        displayName: "ਮਿੰਟ",
        relative: {
          0: "ਇਸ ਮਿੰਟ"
        },
        relativeTime: {
          future: {
            one: "{0} ਮਿੰਟ ਵਿੱਚ",
            other: "{0} ਮਿੰਟਾਂ ਵਿੱਚ"
          },
          past: {
            one: "{0} ਮਿੰਟ ਪਹਿਲਾਂ",
            other: "{0} ਮਿੰਟ ਪਹਿਲਾਂ"
          }
        }
      },
      "minute-short": {
        displayName: "ਮਿੰਟ",
        relative: {
          0: "ਇਸ ਮਿੰਟ"
        },
        relativeTime: {
          future: {
            one: "{0} ਮਿੰਟ ਵਿੱਚ",
            other: "{0} ਮਿੰਟਾਂ ਵਿੱਚ"
          },
          past: {
            one: "{0} ਮਿੰਟ ਪਹਿਲਾਂ",
            other: "{0} ਮਿੰਟ ਪਹਿਲਾਂ"
          }
        }
      },
      second: {
        displayName: "ਸਕਿੰਟ",
        relative: {
          0: "ਹੁਣ"
        },
        relativeTime: {
          future: {
            one: "{0} ਸਕਿੰਟ ਵਿੱਚ",
            other: "{0} ਸਕਿੰਟਾਂ ਵਿੱਚ"
          },
          past: {
            one: "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ",
            other: "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ"
          }
        }
      },
      "second-short": {
        displayName: "ਸਕਿੰਟ",
        relative: {
          0: "ਹੁਣ"
        },
        relativeTime: {
          future: {
            one: "{0} ਸਕਿੰਟ ਵਿੱਚ",
            other: "{0} ਸਕਿੰਟਾਂ ਵਿੱਚ"
          },
          past: {
            one: "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ",
            other: "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ"
          }
        }
      }
    }
  }, {
    locale: "pa-Arab",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      return "other";
    },
    fields: {
      year: {
        displayName: "ورھا",
        relative: {
          0: "this year",
          1: "next year",
          "-1": "last year"
        },
        relativeTime: {
          future: {
            other: "+{0} y"
          },
          past: {
            other: "-{0} y"
          }
        }
      },
      "year-short": {
        displayName: "ورھا",
        relative: {
          0: "this year",
          1: "next year",
          "-1": "last year"
        },
        relativeTime: {
          future: {
            other: "+{0} y"
          },
          past: {
            other: "-{0} y"
          }
        }
      },
      month: {
        displayName: "مہينا",
        relative: {
          0: "this month",
          1: "next month",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            other: "+{0} m"
          },
          past: {
            other: "-{0} m"
          }
        }
      },
      "month-short": {
        displayName: "مہينا",
        relative: {
          0: "this month",
          1: "next month",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            other: "+{0} m"
          },
          past: {
            other: "-{0} m"
          }
        }
      },
      day: {
        displayName: "دئن",
        relative: {
          0: "today",
          1: "tomorrow",
          "-1": "yesterday"
        },
        relativeTime: {
          future: {
            other: "+{0} d"
          },
          past: {
            other: "-{0} d"
          }
        }
      },
      "day-short": {
        displayName: "دئن",
        relative: {
          0: "today",
          1: "tomorrow",
          "-1": "yesterday"
        },
        relativeTime: {
          future: {
            other: "+{0} d"
          },
          past: {
            other: "-{0} d"
          }
        }
      },
      hour: {
        displayName: "گھنٹا",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "+{0} h"
          },
          past: {
            other: "-{0} h"
          }
        }
      },
      "hour-short": {
        displayName: "گھنٹا",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "+{0} h"
          },
          past: {
            other: "-{0} h"
          }
        }
      },
      minute: {
        displayName: "منٹ",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "+{0} min"
          },
          past: {
            other: "-{0} min"
          }
        }
      },
      "minute-short": {
        displayName: "منٹ",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "+{0} min"
          },
          past: {
            other: "-{0} min"
          }
        }
      },
      second: {
        displayName: "Second",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "+{0} s"
          },
          past: {
            other: "-{0} s"
          }
        }
      },
      "second-short": {
        displayName: "Second",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "+{0} s"
          },
          past: {
            other: "-{0} s"
          }
        }
      }
    }
  }, {
    locale: "pa-Guru",
    parentLocale: "pa"
  }];
});